module.exports = __webpack_public_path__ + "img/terms-bg@mb.6767487.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/terms-bg@mb.svg
// module id = qHMG
// module chunks = 7